import { DEFAULT_TELEPHONE_CODE } from "../shared/types";
import { HomeModel, LegalForm } from "./types";
import { defaultAddress } from "../shared/defaults";

// create a stub home model.
export const homeDefaults: HomeModel = {
  manuallyEnteredCompany: {
    isCompanyManuallyEntered: true,
    name: "",
    fullStreet: "",
    address: defaultAddress(),
    phone: {
      code: DEFAULT_TELEPHONE_CODE,
      number: "",
    },
    legalForm: LegalForm.FOUNDATION,
    industryNogaCode: null,
    industryBranchCode: "",
    industrySubBranchCode: "",
    foundationDate: "",
    capitalNom: null,
    enteredInTradeRegistryDate: null,
  },
  selectedCompany: null,
  isCompanyManuallyEntered: false,
};
